/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Skillgroupid2Inputs */

const en_entity_skillgroupid2 = /** @type {(inputs: Entity_Skillgroupid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skill Group ID`)
};

const de_entity_skillgroupid2 = /** @type {(inputs: Entity_Skillgroupid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID`)
};

/**
* | output |
* | --- |
* | "Skill Group ID" |
*
* @param {Entity_Skillgroupid2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_skillgroupid2 = /** @type {((inputs?: Entity_Skillgroupid2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Skillgroupid2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_skillgroupid2(inputs)
	return de_entity_skillgroupid2(inputs)
});
export { entity_skillgroupid2 as "entity_skillGroupId" }